module.exports = __webpack_public_path__ + "img/new_05_workshop_3.5b130f09.jpg";